import { onboardingSchema } from '@/features/onboarding/constants/onboarding.schema';
import { DEFAULT_ONBOARDING_DATA } from '@/features/onboarding/constants/onboardingData';
import {
  type DefaultOnboardingData,
  ONBOARDING_STEPS,
  type OnboardingDoneMap,
  type OnboardingStep,
} from '@/features/onboarding/types/onboardingData';
import { sanitizeWizard } from '@/shared/utils/zod';

export const isStep = (v: string): v is OnboardingStep =>
  (ONBOARDING_STEPS as readonly string[]).includes(v);

export const stepIndex = (id: OnboardingStep) => ONBOARDING_STEPS.indexOf(id);

export const getOnboardingProgress = (step: OnboardingStep): number => {
  const idx = ONBOARDING_STEPS.indexOf(step);
  if (idx === -1) return 0;

  return Math.round(((idx + 1) / ONBOARDING_STEPS.length) * 100);
};

export const getNextStep = (
  step: OnboardingStep,
): OnboardingStep | undefined => {
  const i = stepIndex(step);
  return i >= 0 && i < ONBOARDING_STEPS.length - 1
    ? ONBOARDING_STEPS[i + 1]
    : undefined;
};

export const getPrevStep = (
  step: OnboardingStep,
): OnboardingStep | undefined => {
  const i = stepIndex(step);
  return i > 0 ? ONBOARDING_STEPS[i - 1] : undefined;
};

export const sanitizeOnboarding = (
  data: DefaultOnboardingData,
  done: OnboardingDoneMap,
) => {
  return sanitizeWizard({
    data,
    done,
    steps: ONBOARDING_STEPS,
    defaults: DEFAULT_ONBOARDING_DATA,
    schema: onboardingSchema,
  });
};
